import httpClient from '#utils/httpClient';

export const uploadDocument = async (formData) => {
    const response = await httpClient.post(
        '/api/RequestImgUpload/UploadRequestImage',
        formData,
        {
            headers: {
                'Content-Type': undefined
            }
        }
    );

    return response.data;
};

export const uploadUserProfile = async (formData) => {
    const response = await httpClient.post(
        '/ImgUpload/UploadImage',
        formData,
        {
            headers: {
                'Content-Type': undefined
            }
        }
    );

    return response.data;
};

